$(document).ready(function() {

    if ($('#cookies-bar').length > 0) {
        $('#cookies-close-button').click(function() {
            $.ajax({
                url: $(this).attr('href'),
                type: 'post',
                'headers': {'X-CSRF-TOKEN': $('#tokencook').val()},
                success: function(response) {
                    if (response == 'ok') {
                        $('#cookies-bar').remove();
                    }
                }
            });
            return false;
        });
    }
});




$('#telshow').click(function(e) {
    var obj=$(this);
    $.ajax({
        'async': false,
        'url': '/show_tel/' + +$(this).data('id'),
        'headers': {'X-CSRF-TOKEN': $('#token').val()},
        'type': 'post'
    }).done(function(data)  {       
        obj.closest(".hidden-info").find( ".hidden-info__inner").html(data);
        obj.closest(".hidden-info").addClass("visible");
    });
});
$('#telshow2').click(function(e) {
    var obj=$(this);
    $.ajax({
        'async': false,
        'url': '/show_tel/' + +$(this).data('id'),
        'headers': {'X-CSRF-TOKEN': $('#token').val()},
        'type': 'post'
    }).done(function(data)  {       
        obj.closest(".hidden-info").find( ".hidden-info__inner").html(data);
        obj.closest(".hidden-info").addClass("visible");
    });
});

$('#emailshow').click(function() {
    var obj=$(this);
    $.ajax({
        'async': false,
        'url': '/show_email/' + +$(this).data('id'),
        'headers': {'X-CSRF-TOKEN': $('#token').val()},
        'type': 'post'
    }).done(function(data) {
        obj.closest(".hidden-info").find( ".hidden-info__inner").html(data);
        obj.closest(".hidden-info").addClass("visible");
    });
});


$('#telshow_2').click(function() {
    var obj=$(this);
    $.ajax({
        'async': false,
        'url': '/show_tel2/' + +$(this).data('id'),
        'headers': {'X-CSRF-TOKEN': $('#token').val()},
        'type': 'post'
    }).done(function(data) {
        obj.closest(".hidden-info").find( ".hidden-info__inner").html(data);
        obj.closest(".hidden-info").addClass("visible");
    });
});

$('#emailshow_2').click(function() {
    var obj=$(this);
    $.ajax({
        'async': false,
        'url': '/show_email2/' + +$(this).data('id'),
        'headers': {'X-CSRF-TOKEN': $('#token').val()},
        'type': 'post'
    }).done(function(data) {
        obj.closest(".hidden-info").find( ".hidden-info__inner").html(data);
        obj.closest(".hidden-info").addClass("visible");
    });
});

var gotoExternal = function(url) {
    
    setTimeout(function() {
        document.location = url;
    }, 3000)
   // gtag('event', 'LinkWychodzacy', { 'event_category': 'Kliknięcia' })
   gt('send', 'event', 'LinkWychodzacy', 'Klikniecie', url);
}


$("#star1").on('click', function (event) {
    $("#comment-vote").val($(this).val());
});
$("#star2").on('click', function (event) {
    $("#comment-vote").val($(this).val());
});
$("#star3").on('click', function (event) {
    $("#comment-vote").val($(this).val());
});
$("#star4").on('click', function (event) {
    $("#comment-vote").val($(this).val());
});
$("#star5").on('click', function (event) {
    $("#comment-vote").val($(this).val());
});